import React from "react";

import {CircularProgress} from "@mui/joy";
import Chip from "@mui/joy/Chip";

// components
import {retrieveComponentCard, } from "./utils";


class ComponentCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            card: null,
        };
    }

    async componentDidMount() {
        let [card, title] = await retrieveComponentCard(
            this.props.entity,
            this.props.entity_id,
            this.props.mini,
            this.props.nano,
        )
        this.setState(
            {
                card: card,
                title: title,
            }
        );
    }

    render() {
        if (!this.state.card) {
            return (<CircularProgress/>)
        }
        return(
            <>
                {
                    this.props.showTitle?
                        <Chip
                            color={'neutral'}
                        >
                            {this.state.title}
                        </Chip>:
                        null
                }
                {this.state.card}
            </>
        )
    }
}

export default ComponentCard
